<template>
  <div id="ctn-list">
  <!--  <b-card>-->
      <div v-show="hide_details || false" class="mr-auto float-right">
        <span
          class="btn btn-danger ml-2"
          @click="hide_details()"
        >
          <i class="fa fa-times" aria-hidden="true"></i>
        </span>
      </div>
      
      <div class="mr-auto float-right" v-show="getTotalRows > 0">
        <button
          class="btn btn-info ml-2"
          @click="create_proforma()"
          v-show="show_proforma_btn"
        >
          <span v-show="!is_generating_proforma">PROFORMA</span> 
          <b-spinner variant="info" label="Spinning" v-show="is_generating_proforma"/>
        </button>
        <button
          class="btn btn-success ml-2"
          @click="create_authorization()"
          v-show="show_authorization_btn"
        >
          <span v-show="!is_generating_authorization">AUTHORIZATION</span> 
          <b-spinner variant="info" label="Spinning" v-show="is_generating_authorization"/>
        </button>

<!--
        <div class="btn-group ml-2">
          <button type="button" class="btn btn-danger">AUTHORIZATION</button>
          <button type="button" class="btn btn-danger dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="sr-only">Toggle Dropdown</span>
          </button>
          <div class="dropdown-menu">
            <a class="dropdown-item" href="#">To leave the termal</a>
            <a class="dropdown-item" href="#">To take goods in truck</a>
            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#">To verify goods</a>
          </div>
        </div>
-->        
      </div>
      
      <div class="mr-auto float-left" v-if="search_bar">
        <ContainerSearch class="mb-2" />
      </div>

      <div class="mr-auto float-left" v-else>
        <b-form-group>
          <b-input-group size="sm">
            <b-form-input
              v-model="filter"
              type="search"
              id="filterInput"
              placeholder="Type to Search"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </div>

      <div class="text-sm border-1">
        <b-table
          id="table-unit-list"
          primary-key="id_ctn"
          class="table-grid"
          striped
          hover
          outlined
          show-empty
          table-variant="light"
          :empty-text="get_empty_text"
          empty-filtered-text="There are no records matching your request"
          :items="getUnitList"
          :fields="get_unit_fields(search_type)"
          :per-page="perPage"
          :current-page="currentPage"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <!--
          v-show="getTotalRows > 0 || filter"
        <template v-slot:thead-top>
          <b-tr>
            <b-th colspan="4" variant="primary">Information</b-th>
            <b-th colspan="3" variant="secondary">Dates</b-th>
            <b-th colspan="5" variant="danger">Amounts</b-th>
            <b-th colspan="1" variant="warning"></b-th>
          </b-tr>
        </template>
          -->
          <template v-slot:cell(gross_amount)="data">
            <span>{{ data.value | numFormat(currency_format) }}</span>
          </template>
          <template v-slot:cell(waived_amount)="data">
            <span>{{ data.value | numFormat(currency_format) }}</span>
          </template>
          <template v-slot:cell(net_amount)="data">
            <span>{{ data.value | numFormat(currency_format) }}</span>
          </template>
          <template v-slot:cell(paid_amount)="data">
            <span>{{ data.value | numFormat(currency_format) }}</span>
          </template>
          <template v-slot:cell(unpaid_amount)="data">
            <span>{{ data.value | numFormat(currency_format) }}</span>
          </template>

          <template v-slot:cell(show_details)="row">
            <span
              class="btn btn-primary btn-sm"
              @click="row.toggleDetails"
              v-b-tooltip.hover
              title="Hide details"
              v-show="row.detailsShowing"
            >
              <i class="fa fa-eye-slash" aria-hidden="true"></i>
            </span>
            <span
              class="btn btn-primary btn-sm"
              @click="row.toggleDetails"
              v-b-tooltip.hover
              title="Show details"
              v-show="!row.detailsShowing"
            >
              <i class="fa fa-eye" aria-hidden="true"></i>
            </span>
          </template>

          <template v-slot:row-details="row">
            <b-container>
              <div
                v-if="row.item.deposit != 0"
              >Deposit due : {{ row.item.deposit | numFormat(currency_format) }}</div>
              <b-table
                id="table-unit-charges"
                primary-key="id_charge"
                striped
                hover
                small
                outlined
                table-variant="light"
                head-variant="dark"
                :items="row.item.charges"
                :fields="charge_fields"
              >
                <template v-slot:cell(rate)="data">
                  <span>{{ data.value | numFormat(currency_format) }}</span>
                </template>
                <template v-slot:cell(gross_amount)="data">
                  <span>{{ data.value | numFormat(currency_format) }}</span>
                </template>
                <template v-slot:cell(waived_amount)="data">
                  <span>{{ data.value | numFormat(currency_format) }}</span>
                </template>
                <template v-slot:cell(net_amount)="data">
                  <span>{{ data.value | numFormat(currency_format) }}</span>
                </template>
                <template v-slot:cell(paid_amount)="data">
                  <span>{{ data.value | numFormat(currency_format) }}</span>
                </template>
                <template v-slot:cell(unpaid_amount)="data">
                  <span>{{ data.value | numFormat(currency_format) }}</span>
                </template>

                <template #empty="scope">
                  <h4>{{ scope.emptyText }}</h4>
                </template>
                <template #emptyfiltered="scope">
                  <h4>{{ scope.emptyFilteredText }}</h4>
                </template>
              </b-table>
            </b-container>
          </template>

          <template slot="bottom-row" v-if="!filter && getTotalRows>1">
            <td></td>
            <td v-show="showCarrierColumn"></td>
            <td v-show="showConsigneeColumn"></td>
            <td></td>
            <td></td>
            <td></td>
            <td v-show="showGateOut || showGateIn"></td>
            <td >Total : </td>
            <td class="text-right">{{ getTotalGross | numFormat(currency_format) }}</td>
            <td class="text-right">{{ getTotalWaived | numFormat(currency_format) }}</td>
            <td class="text-right">{{ getTotalNet | numFormat(currency_format) }}</td>
            <td class="text-right">{{ getTotalPaid | numFormat(currency_format) }}</td>
            <td class="text-right">{{ getTotalUnpaid | numFormat(currency_format) }}</td>
            <td></td>
          </template>
        </b-table>
        <b-pagination
          v-show="getTotalRows > perPage"
          v-model="currentPage"
          :total-rows="getTotalRows"
          :per-page="perPage"
          aria-controls="my-table"
          align="fill"
          size="sm"
        />
    </div>
    <!-- </b-card> -->
  </div>
</template>

<script>
import ContainerSearch from "@/components/portal/ContainerSearch";
export default {
  name: "ContainerList",
  components: {
    ContainerSearch,
  },
  props: {
    search_type: String,
    search_bar: Boolean,
    numberUnitPerPage: Number,
    //show_age: Boolean,
    hide_details: Function,
    //refresh_data: Function,
    //recap_data: {
    //  type: Array,
    //  required: true,
    //},
  },
  data() {
    return {
      is_generating_proforma: false,
      is_generating_authorization: false,
      first_load: true,
      currency_format: "$ 0,0.00",
      currentPage: 1,
      totalRows: 0,
      TotalUnpaid: 0,
      unit_fields: [
        { key: "id_ctn", label: "ID", sortable: true, hidden: true },
        { key: "carrier_code", label: "Carrier", sortable: true },
        { key: "consignee_name", label: "Consignee", sortable: true },
        { key: "bol_reference", label: "Bill of lading", sortable: true },
        { key: "ctn_reference", label: "Container", sortable: true },
        {
          key: "di_date",
          label: "Discharge",
          sortable: true,
          formatter: (value) => {
            return value == "0000-00-00" ? "" : value;
          },
        },
        {
          key: "go_date",
          label: "Gate Out",
          sortable: true,
          formatter: (value) => {
            return value == "0000-00-00" ? "" : value;
          },
        },
        {
          key: "gi_date",
          label: "Gate In",
          sortable: true,
          formatter: (value) => {
            return value == "0000-00-00" ? "" : value;
          },
        },
        {
          key: "last_free_day",
          label: "Last free day",
          sortable: true,
          formatter: (value) => {
            return value == "0000-00-00" ? "" : value;
          },
        },
        {
          key: "gross_amount",
          label: "Gross",
          sortable: true,
          class: "text-right",
        },
        {
          key: "waived_amount",
          label: "Waived",
          sortable: true,
          class: "text-right",
        },
        {
          key: "net_amount",
          label: "Net",
          sortable: true,
          class: "text-right",
        },
        {
          key: "paid_amount",
          label: "Paid",
          sortable: true,
          class: "text-right",
        },
        {
          key: "unpaid_amount",
          label: "Balance",
          sortable: true,
          class: "text-right",
        },
        { key: "show_details", label: "", class: "text-right", },
      ],
      charge_fields: [
        { key: "id_charge", label: "ID" },
        { key: "phase", label: "Charge" },
        { key: "free_days", label: "Free days", class: "text-right" },
        {
          key: "late_start_on",
          label: "Late Start On",
          formatter: (value) => {
            return value == "0000-00-00" ? "" : value;
          },
        },
        { key: "late", label: "Late", class: "text-right" },
        { key: "rate", label: "Rate", class: "text-right" },
        { key: "gross_amount", label: "Gross", class: "text-right" },
        { key: "waived_amount", label: "Waived", class: "text-right" },
        { key: "net_amount", label: "Net", class: "text-right" },
        { key: "paid_amount", label: "Paid", class: "text-right" },
        { key: "unpaid_amount", label: "Balance", class: "text-right" },
      ],
      filter: null,
      filterOn: ["carrier_code", "consignee", "bol_reference", "ctn_reference"],
      filteredItems: [],
    };
  },
  computed: {
    searchTypeIndication() {
      if (this.search_type == "FULL_AT_TERMINAL") {
        return "Full at terminal";
      } else if (this.search_type == "FULL_AT_CONSIGNEE") {
        return "Full at consignee";
      } else if (this.search_type == "UNPAID_EMPTY_UNITS") {
        return "Outstanding";
      } else {
        return "Found";
      }
    },
    show_proforma_btn(){
      return this.getTotalRows > 0 
        && this.$store.state.permission_list.findIndex(item=>item.permission == "1") >= 0;
    },
    show_authorization_btn(){
      return this.getTotalRows > 0 
        && this.can_create_authorization
        && (this.search_type == "FULL_AT_TERMINAL" || this.search_type == undefined);
    },
    can_create_proforma() {
      try {
        return this.$store.state.permission_list.findIndex(item=>item.permission == "1") >= 0;
      } catch {
        return false;
      }
    },
    can_create_authorization() {
      try {
        return this.$store.state.permission_list.findIndex(item=>item.permission == "2") >= 0;
      } catch {
        return false;
      }
    },
    showGateIn(){
      if (this.search_type == "FULL_AT_CONSIGNEE" || this.search_type == "FULL_AT_TERMINAL") return false;
      return true;
    },
    showGateOut(){
      if (this.search_type == "FULL_AT_TERMINAL") return false;
      return true;
    },
    showCarrierColumn(){
      return this.$store.state.current_profile.type == 4 ? false : true;
    },
    showConsigneeColumn(){
      return this.$store.state.current_profile.type == 6 ? false : true;
    },
    get_empty_text() {
      return this.first_load ? "Please type a bill of lading or container reference then click on the 'SEARCH' button" : "There are no records matching your request";
    },
    getTotalGross() {
      try {
        return this.filter
          ? this.filteredItems.reduce((sum, cv) => sum + cv.gross_amount, 0)
          : this.getUnitList.reduce((sum, cv) => sum + cv.gross_amount, 0);
      } catch {
        return 0;
      }
    },
    getTotalWaived() {
      try {
        return this.filter
          ? this.filteredItems.reduce((sum, cv) => sum + cv.waived_amount, 0)
          : this.getUnitList.reduce((sum, cv) => sum + cv.waived_amount, 0);
      } catch {
        return 0;
      }
    },
    getTotalPaid() {
      try {
        return this.filter
          ? this.filteredItems.reduce((sum, cv) => sum + cv.paid_amount, 0)
          : this.getUnitList.reduce((sum, cv) => sum + cv.paid_amount, 0);
      } catch {
        return 0;
      }
    },
    getTotalNet() {
      try {
        return this.filter
          ? this.filteredItems.reduce((sum, cv) => sum + cv.net_amount, 0)
          : this.getUnitList.reduce((sum, cv) => sum + cv.net_amount, 0);
      } catch {
        return 0;
      }
    },
    getTotalUnpaid() {
      try {
        return this.filter
          ? this.filteredItems.reduce((sum, cv) => sum + cv.unpaid_amount, 0)
          : this.getUnitList.reduce((sum, cv) => sum + cv.unpaid_amount, 0);
      } catch {
        return 0;
      }
    },
    getTotalRows() {
      try {
        return this.filter ? this.totalRows : this.getUnitList.length;
      } catch {
        return 0;
      }
    },
    perPage() {
      return this.numberUnitPerPage <= 0
        ? this.getTotalRows()
        : this.numberUnitPerPage;
    },
    getUnitList: function () {
      if (this.search_type == "FULL_AT_TERMINAL") {
        return this.$store.getters.units_at_terminal;
      } else if (this.search_type == "FULL_AT_CONSIGNEE") {
        return this.$store.getters.units_at_consignee;
      } else if (this.search_type == "UNPAID_EMPTY_UNITS") {
        return this.$store.getters.units_with_outstanding;
      } else {
        return this.$store.getters.units_list;
      }
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.TotalUnpaid = filteredItems.reduce(
        (sum, cv) => sum + cv.unpaid_amount,
        0
      );

      this.currentPage = 1;
    },

    get_unit_fields(s) {
      let cp = this.$store.state.current_profile;
      return this.unit_fields.filter(function (u) {
        let show = true;
        if (s == "FULL_AT_TERMINAL") {
          show = (u.key != "go_date" && u.key != "gi_date");
        } else if (s == "FULL_AT_CONSIGNEE") {
          show = (u.key != "gi_date");
        } else {
          show = (u.key != "last_free_day");
        }
        if (!show) return false;
        if (u.key == "carrier_code" && cp.type == 4) return false
        if (u.key == "consignee_name" && cp.type == 6) return false
        return show;
      });
    },

    create_proforma: function () {
      //carrier_code, client_id
      this.is_generating_proforma = true
      let ctn_ids = this.getUnitList.map((x) => {
        return x.id_ctn;
      }).toString();
    
      //var payload = { carrier: carrier_code, client_id: client_id };
      var payload = { ctn_ids };
      this.$store.dispatch("create_proforma", payload)
      .then(() => {
        this.is_generating_proforma = false;
        this.$toast
          .success("The proforma was succesfuly sent to your inbox. Please check your email ", {
            position: "top",
            //onClose: () => this.$router.push("/portal"),
          });
      }).catch(() => {
        this.is_generating_proforma = false;
        this.$toast
          .error("Unfortunatly, an error accoured while generating the proforma. ", {
            position: "top",
            //onClose: () => this.$router.push("/portal"),
          });
      });
    },

    create_authorization: function () {
      //carrier_code, client_id
      this.is_generating_authorization = true
      let ctn_ids = this.getUnitList.map((x) => {
        return x.go_date == "0000-00-00" ? x.id_ctn : 0;
      }).toString();
    
      //var payload = { carrier: carrier_code, client_id: client_id };
      var payload = { ctn_ids };
      this.$store.dispatch("create_authorization", payload)
      .then(() => {
        this.is_generating_authorization = false;
        this.$toast
          .success("The authorization was succesfuly sent to your inbox. Please check your email ", {
            position: "top",
            //onClose: () => this.$router.push("/portal"),
          });
      }).catch((error) => {
        this.is_generating_authorization = false;
        let msg = "Unfortunatly, the authorization could not be generated. </br> Reason : "+error.response.data.fault.faultstring;
        this.$toast
          .error(msg, {
            position: "top",
            //onClose: () => this.$router.push("/portal"),
          });
      });
    },
  },
};
</script>
